export default {
  name: 'StarRating',
  props: [
    'attributeName',
    'attributeId',
    'initialValue',
    'ratings',
    'hasError',
  ],
  data() {
    return {
      checkedValue: this.initialValue,
      ratingItems: JSON.parse(this.ratings),
    }
  },
  created() {
    this.isActive
  },
  computed: {
    isActive() {
      this.ratingItems = this.ratingItems.map(item => ({
        ...item,
        active: this.checkedValue >= item.value,
        checked: this.checkedValue == item.value,
      }))
    },
  },
  methods: {
    toggleStar(e) {
      this.checkedValue = e.target.previousSibling.value
      this.isActive
    },
  },
}
